function i(e, s = [], c) {
  const n = {};
  return Object.getOwnPropertyNames(e).forEach((t) => {
    s.includes(t) || (n[t] = e[t]);
  }), Object.assign(n, c);
}
export {
  i as omit
};
